import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { useAuth, formatApiErrorDetail } from '../context/AuthContext';
import { AuthShell, AuthDivider, GoogleButton, Field } from '../components/AuthShell';

const LoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(email, password);
      toast.success('Welcome back!');
      navigate(data.account.role === 'super_admin' ? '/super' : '/admin');
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Organiser login" subtitle="For event organisers, agencies and photo teams. Guests don't need an account — use the album link or QR you received after registering." testId="login-card">
      <form onSubmit={handleSubmit} className="space-y-4">
        <Field label="Email">
          <input data-testid="login-email-input" type="email" className="input" placeholder="you@company.com" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </Field>
        <Field label="Password">
          <input data-testid="login-password-input" type="password" className="input" placeholder="••••••••" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </Field>
        <button data-testid="login-submit-btn" type="submit" disabled={loading} className="btn-primary w-full">
          {loading && <Loader2 className="w-4 h-4 animate-spin" />}
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
      <AuthDivider />
      <GoogleButton />
      <p className="text-center text-sm text-slate-400">
        New here?{' '}
        <Link to="/signup" className="font-bold text-cyan hover:underline" data-testid="go-signup-link">Create a workspace</Link>
      </p>
    </AuthShell>
  );
};

export default LoginPage;
